import * as React from 'react';
import classnames from 'classnames';
import { snap, visualize } from 'storybook-snapper';
import { Text } from '../Text';
import { LegacyCard, LegacyCardRatioOptions } from '..';
import { classes } from './LegacyCard.visual.st.css';

const IMAGE_SRC =
  'https://static.wixstatic.com/media/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg/v1/fill/w_791,h_317,al_c,lg_1,q_80,enc_auto/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg';

const LegacyCardVisual = (props) => {
  return (
    <LegacyCard
      className={classnames(classes.root, {
        [classes.override]: props.withOverride,
        [classes.stacked]: props.stacked,
      })}
      info={
        <>
          <Text>Info part</Text>
        </>
      }
      media={
        <img
          src={IMAGE_SRC}
          alt="My product"
          width="100%"
          height="auto"
          style={{ verticalAlign: 'middle', opacity: 0.5 }}
        />
      }
      {...props}
    />
  );
};

visualize('Deprecated Card', () => {
  snap('default', <LegacyCardVisual />);
  snap('with style overrides', <LegacyCardVisual withOverride />);
  snap(
    'ratio',
    <LegacyCardVisual ratio={LegacyCardRatioOptions.RATIO_40_60} />,
  );
  snap('stacked', <LegacyCardVisual stacked />);
  snap(
    'stacked with style override',
    <LegacyCardVisual stacked withOverride />,
  );
});
